import { NgModule } from '@angular/core';

import { ApButtonComponent } from '@ap/button';
import { ApContentModule } from '@ap/content';

import { StartComponent } from './start.component';

/**
 * @ngdoc module
 * @name StartModule
 **/
@NgModule({
    imports: [ApButtonComponent, ApContentModule],
    declarations: [StartComponent],
    exports: [StartComponent]
})
export class StartModule {}
